export default __webpack_public_path__ + "src/assets/UnstoppableDomains_Mobile.26eb5db7a451d940090b8384d9a97c56.svg";